var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dots 05") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e95c53",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "nc-loop_dots-05-24"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    cx: 12,
    cy: 12,
    r: 2,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#e95c53",
    cx: 3,
    cy: 12,
    r: 2,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#e95c53",
    cx: 21,
    cy: 12,
    r: 2,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("script", null, "!function(){function t(t){this.element=t,this.dots=[this.element.getElementsByTagName(\"circle\")[1],this.element.getElementsByTagName(\"circle\")[0],this.element.getElementsByTagName(\"circle\")[2]],this.animationId,this.start=null,this.init()}if(!window.requestAnimationFrame){var i=null;window.requestAnimationFrame=function(t,n){var e=(new Date).getTime();i||(i=e);var a=Math.max(0,16-(e-i)),o=window.setTimeout(function(){t(e+a)},a);return i=e+a,o}}t.prototype.init=function(){var t=this;this.animationId=window.requestAnimationFrame(t.triggerAnimation.bind(t))},t.prototype.reset=function(){var t=this;window.cancelAnimationFrame(t.animationId)},t.prototype.triggerAnimation=function(t){var i=this;this.start||(this.start=t);var n=t-this.start,e=Math.min(n/40,23);930>n||(this.start=this.start+930);for(var a=[],o=0;3>o;o++){a[o]=Math.max(e-2*o,0);if(a[o]>6)(a[o]=12-a[o]);a[o]=Math.max(a[o],0),this.dots[o].setAttribute(\"transform\",\"translate(0 \"+a[o]+\")\");}if(document.documentElement.contains(this.element))window.requestAnimationFrame(i.triggerAnimation.bind(i))};var n=document.getElementsByClassName(\"nc-loop_dots-05-24\"),e=[];if(n)for(var a=0;n.length>a;a++)!function(i){e.push(new t(n[i]))}(a);document.addEventListener(\"visibilitychange\",function(){\"hidden\"==document.visibilityState?e.forEach(function(t){t.reset()}):e.forEach(function(t){t.init()})})}();"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.d3892b52bb790d4ac10e75b20d23605a.svg";
export { ForwardRef as ReactComponent };